import React, { Component } from 'react';
import Radium from 'radium';
import Colors from '../utils/colors';
import Breakpoints from '../utils/breakpoints';
import contentfulData from '../../contentfuldata/data.json';
import 'whatwg-fetch';

class NewsLetter extends Component {

  constructor(props, context){
    super(props, context);
    this.state = {
       email: "",
       formSent: {error: "", success: ""},
       newsletterSent: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.orderNewsletter = this.orderNewsletter.bind(this);
  }

  orderNewsletter(e){
    const formUrl = "https://cx5j4s9rc2.execute-api.eu-west-1.amazonaws.com/prod/SaveEmailToS3";
    const brand = getLang();
    const successText = contentfulData.singleData[brand].singleData.formSentText;
    this.setState({
      newsletterSent: true
    });
    if (this.state.email.length > 3){
      fetch(formUrl, {
        method: 'POST',
        mode: 'no-cors',
        headers: {'Access-Control-Allow-Origin':'*'},
        body: JSON.stringify({email: this.state.email})
      })
      .then(response => response)
      .then(json => {
        this.setState({
          formSent: {success: successText},
          email: ""
        })
      })
      .catch(ex => {
        this.setState({
          email: ""
        });
      });
    }
  }

  handleChange(event){
    const target = event.target;
    this.setState({
      email: target.value
    });
  }

  render() {
    return (
        <div style={styles.main}>
          <div className="col-sm-6" style={styles.text}>
            <p>{this.props.text}</p>
          </div>
          <div className="col-sm-6">
            { !this.state.newsletterSent &&
              <div className="input-group">
                <input style={styles.input} className="form-control" placeholder="E-mail" value={this.state.email} onChange={this.handleChange}/> <span className="input-group-addon" onClick={this.orderNewsletter}><i className="glyphicon glyphicon-chevron-right" style={styles.icon}></i></span>
              </div>
            }
            {this.state.formSent.success!=="" &&
              <div style={styles.formsent} className="col-xs-12">
                {this.state.formSent.success}
              </div>
            }
          </div>
          <div className="clearfix"></div>
        </div>
    );
  }
}

const styles = {
  main: {
    backgroundColor: Colors.darkBlue,
    padding: 30,
    borderRadius: Breakpoints.borderRadius,
    [Breakpoints.media.siteUnderMaxWidth]: {
      paddingTop: 15,
      paddingLeft: 15,
      paddingRight: 15,
      paddingBottom: 30
    },
  },
  input: {
    padding: 30,
    [Breakpoints.media.siteUnderMaxWidth]: {
      padding: 10
    }
  },
  icon: {
    padding: 17,
    [Breakpoints.media.siteUnderMaxWidth]: {
      padding: 0,
      fontSize: 12
    },
  },
  text: {
    color: '#ffffff'
  },
  formsent: {
    marginTop: 10,
    padding: 18,
    backgroundColor: "#218838",
    color: "#ffffff",
    textAlign: 'center',
    textTransform: 'uppercase',
    borderRadius: Breakpoints.borderRadius
  }
};

export default Radium(NewsLetter);


// WEBPACK FOOTER //
// ./src/components/NewsLetter.js